export default {
  header: 'Definície parametrov zariadenia',
  subheader: 'Táto stránka umožňuje spravovať vlastné parametre zariadenia, ktoré môžu byť opätovne použité v nástroji na tvorbu signálov.',
  empty: 'Nie sú definované žiadne vlastné parametre zariadenia.',
  confirmDelete: {
    header: 'Potvrdiť odstránenie',
    message: 'Chystáte sa odstrániť vlastnú definíciu parametra. Táto definícia môže byť používaná viacerými zariadeniami.\n\nNaozaj chcete natrvalo odstrániť parameter "{parameter}"?',
  },
};
